import { c as _c } from "react/compiler-runtime";
import React, { use } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import WarehouseIdHydrator from 'global-state/warehouseIdForUser/WarehouseIdHydrator';
import SuspenseWithLoader from '../SuspenseWithLoader';
import buildPdpDesktopHeroLcpUrl from './PDPDesktopHeroGallery/helpers/buildPdpDesktopHeroLcpUrl';
import PDPContextRegion from './PDPContextRegion';
import PDPContextRegionPlaceholder from './PDPContextRegionPlaceholder';
import PDPLayoutRevampSeedBoundary from './PDPLayoutRevampSeedBoundary';

/**
 * Resolves only hero-related server promises so LCP preload (and the context
 * fallback hero image) can paint without waiting on options / basicDetails /
 * stock / protection.
 */
const PDPHeroShell = t0 => {
  const $ = _c(33);
  const {
    slugOverride: t1,
    isEditOrder: t2,
    pdpIsModularBYOProduct: t3,
    productOptionsPromise,
    productHeroImagePromise,
    productCylindoHeroImagePromise,
    productBasicDetailsPromise,
    productIdentityPromise: t4,
    warehouseIdPromise,
    layoutRevampContextPromise
  } = t0;
  const slugOverride = t1 === undefined ? null : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const productIdentityPromise = t4 === undefined ? null : t4;
  const productHeroImageFromServer = productHeroImagePromise ? use(productHeroImagePromise) : null;
  const productCylindoHeroImage = productCylindoHeroImagePromise ? use(productCylindoHeroImagePromise) : null;
  const heroSrcForPreload = productHeroImageFromServer?.src || productCylindoHeroImage?.src || null;
  let t5;
  if ($[0] !== heroSrcForPreload) {
    t5 = heroSrcForPreload ? buildPdpDesktopHeroLcpUrl(heroSrcForPreload) ?? heroSrcForPreload : null;
    $[0] = heroSrcForPreload;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const heroPreloadHref = t5;
  let t6;
  if ($[2] !== isEditOrder || $[3] !== pdpIsModularBYOProduct || $[4] !== productCylindoHeroImage || $[5] !== productHeroImageFromServer) {
    t6 = <PDPContextRegionPlaceholder productHeroImage={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[2] = isEditOrder;
    $[3] = pdpIsModularBYOProduct;
    $[4] = productCylindoHeroImage;
    $[5] = productHeroImageFromServer;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const regionPlaceholder = t6;
  let t7;
  if ($[7] !== heroPreloadHref) {
    t7 = heroPreloadHref ? <Helmet><link rel="preload" as="image" href={heroPreloadHref} media="(min-width: 1024px)" fetchPriority="high" /></Helmet> : null;
    $[7] = heroPreloadHref;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = pdpIsModularBYOProduct || isEditOrder ? null : layoutRevampContextPromise;
  let t9;
  if ($[9] !== isEditOrder || $[10] !== pdpIsModularBYOProduct || $[11] !== productBasicDetailsPromise || $[12] !== productCylindoHeroImage || $[13] !== productHeroImageFromServer || $[14] !== productIdentityPromise || $[15] !== productOptionsPromise || $[16] !== slugOverride) {
    t9 = <PDPContextRegion slugOverride={slugOverride} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} productOptionsPromise={productOptionsPromise} productBasicDetailsPromise={productBasicDetailsPromise} productIdentityPromise={productIdentityPromise} productHeroImageFromServer={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} />;
    $[9] = isEditOrder;
    $[10] = pdpIsModularBYOProduct;
    $[11] = productBasicDetailsPromise;
    $[12] = productCylindoHeroImage;
    $[13] = productHeroImageFromServer;
    $[14] = productIdentityPromise;
    $[15] = productOptionsPromise;
    $[16] = slugOverride;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9 || $[19] !== warehouseIdPromise) {
    t10 = <WarehouseIdHydrator warehouseIdPromise={warehouseIdPromise}>{t9}</WarehouseIdHydrator>;
    $[18] = t9;
    $[19] = warehouseIdPromise;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== regionPlaceholder || $[22] !== t10) {
    t11 = <SuspenseWithLoader fallback={regionPlaceholder}>{t10}</SuspenseWithLoader>;
    $[21] = regionPlaceholder;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t8) {
    t12 = <PDPLayoutRevampSeedBoundary contextPromise={t8}>{t11}</PDPLayoutRevampSeedBoundary>;
    $[24] = t11;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== regionPlaceholder || $[28] !== t12) {
    t13 = <SuspenseWithLoader fallback={regionPlaceholder}>{t12}</SuspenseWithLoader>;
    $[27] = regionPlaceholder;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t7) {
    t14 = <>{t7}{t13}</>;
    $[30] = t13;
    $[31] = t7;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
PDPHeroShell.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productOptionsPromise: PropTypes.object,
  productHeroImagePromise: PropTypes.object,
  productCylindoHeroImagePromise: PropTypes.object,
  productBasicDetailsPromise: PropTypes.object,
  productIdentityPromise: PropTypes.object,
  warehouseIdPromise: PropTypes.object,
  layoutRevampContextPromise: PropTypes.object
};
export default PDPHeroShell;